module.exports = __webpack_public_path__ + "img/segunda.3f8710f3.jpg";